module.exports = __webpack_public_path__ + "static/directory_2@3x-e96d28a910f35535e989e6e4b9bcfb3a.png";